import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { Bar } from 'react-chartjs-2';
import { Doughnut } from 'react-chartjs-2';
import {Pie} from 'react-chartjs-2'
import EmailIcon from '@material-ui/icons/Email';
import PriorityHigh from '@material-ui/icons/PriorityHigh';
import Edit from '@material-ui/icons/Edit';
import NotificationImportant from '@material-ui/icons/NotificationImportant';
import Tooltip from '@material-ui/core/Tooltip';
//tabs related import
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Paper from '@material-ui/core/Paper';
import Badge from '@material-ui/core/Badge';
import { Divider, Hidden } from '@material-ui/core';

import { grid_spacing, styles } from '../CSS/Styles';

class RoutineIndex extends React.Component {

	handleIdexRoute = (route) => {
		if (route != null){
			this.props.handleRoute(route,route);
		}
	}

	render(){
		const { classes } = this.props;
		return(
			<div>
	            <Grid container justify="flex-start">
	            	{this.props.data.map((dataitem)=>{
	            		if(dataitem.text == null) {
	            			return null
	            		}
	            		return (
	            			<Tooltip classes={{ tooltip: classes.tooltipcustomWidth }} interactive title={dataitem.text}>
                                <Card
                                    className={dataitem.route == '' ? classes.indexing_cardL4_non_clickable : classes.indexing_cardL4_clickable}
                                    onClick={() => {
                                        if (dataitem.route == '')
                                            return;
                                        this.handleIdexRoute(dataitem.route)
                                    }}
                                >
		            				<CardActionArea className={classes.cardAction}>
			            			    <CardContent className={classes.indexing_card_content}>
			            			    	<i class={"fas " + dataitem.icon + " fa-3x"} style={{display:"block", marginTop:'20%', marginBottom:'5%'}}></i>
			            			        <Typography variant="body1" align="center" className={classes.white} style={{display:"block", margin: "5%"}}>
			            			            {dataitem.text.length>60? dataitem.text.substring(0,55)+"...":dataitem.text}
			            			        </Typography>
			            			    </CardContent>
		            			    </CardActionArea>
		            			</Card>
	            			</Tooltip>
	            		)
	            	})}
	            </Grid>
	        </div>
		)
	}
}

export default withStyles(styles)(RoutineIndex)


// WEBPACK FOOTER //
// ./src/components/Routines/RoutineIndex.js